module.exports = __webpack_public_path__ + "media/images/athletes/3950-72a22e52cc9a358f7147b82c04962c45.png";